// extracted by mini-css-extract-plugin
module.exports = {"allergenIconContainer":"AllergenIcon_allergenIconContainer__Hy3Ww","allergenIcon":"AllergenIcon_allergenIcon__Dsv_3","allergenText":"AllergenIcon_allergenText__ws8NZ"};